import adminPanel from './adminPanel';

const colors = {
  // Grupo de tokens exclusivo del panel administrativo. Adición: no
  // sustituye ni reutiliza `brand`, que sigue siendo el color del sitio
  // público.
  adminPanel,
  brand: {
    950: '#061a33',
    900: '#08284a',
    800: '#0b3765',
    700: '#074e9b',
    600: '#075fc7',
    500: '#0b6fe8',
    100: '#eef5ff',
    50: '#f4f7fb',
  },
  whatsapp: {
    500: '#25d366',
    600: '#1fb457',
  },
  positive: {
    500: '#16a34a',
  },
  accentYellow: {
    50: '#FFFBEA',
    100: '#FFF3BF',
    200: '#FFE58A',
    300: '#FFD54F',
    400: '#FBC02D',
    500: '#F5B700',
    600: '#D99F00',
    700: '#B78100',
    800: '#8F6500',
    900: '#684A00',
  },
};

export default colors;
